// Reusable section header photograph that fades naturally into the section background.
// Never renders as a bordered card. Used above dark and light sections.
export default function SectionHeader({ src, alt = "", fadeTo = "black", heightMobile = 260, heightDesktop = 360 }) {
  const bg = fadeTo === "white" ? "#FFFFFF" : fadeTo === "yellow" ? "#F4C10A" : "#0A0A0A";
  return (
    <div
      data-testid="section-header"
      style={{ background: bg }}
      className="relative w-full overflow-hidden"
    >
      <div
        className="relative w-full"
        style={{
          height: `min(${heightMobile}px, 40vh)`,
        }}
      >
        <img src={src} alt={alt} className="absolute inset-0 w-full h-full object-cover object-center block" />
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            background: `linear-gradient(180deg, ${bg} 0%, transparent 25%, transparent 65%, ${bg} 100%)`,
          }}
        />
      </div>
      <style>{`
        @media (min-width: 768px) {
          [data-testid="section-header"] > div:first-of-type {
            height: ${heightDesktop}px !important;
          }
        }
      `}</style>
    </div>
  );
}
